import Logger from './Logger';
import { store } from './store/store';

const logger = new Logger('Spotpages');

export default class Spotpages
{
	constructor(pageNumber, roomClient)
	{
		this._startRange = 0;
		this._endRange = 0;
		this._maxPeers = 0;
		this.thisScreen = pageNumber;
		this._pageNumber = pageNumber;
		this._peerList = [];
		this._activeVideoConsumers = [];
		this._selectedSpotpages = [];
		this._currentPages = [];
		this._roomClient = roomClient;
		this._seatLimit = 4;
	}

	addPeers(peers)
	{
		for (const peer of peers)
		{
			const index = this._peerList.findIndex((each) => each.id ===peer.id);

			if (index === -1)
			{
				logger.debug('adding peer [peerId: "%s"]', peer.id);

				const peerObj = { id: peer.id, displayName: peer.displayName };

				this._spotpagesUpdated(peerObj);

				this._peerList.push({ id: peer.id, displayName: peer.displayName });
			}
		}

	}

	async newPeer(peer)
	{
		logger.debug(
			'room "newpeer" event [id: "%s"]', peer.id);

		const index = this._peerList.findIndex((each) => each.id === peer.id);

		if (index === -1) // We don't have this peer in the list
		{
			logger.debug('_handlePeer() | adding peer [peerId: "%s"]', peer);

			const peerObj = { id: peer.id, displayName: peer.displayName };

			this._peerList.push({ id: peer.id, displayName: peer.displayName });

			// console.log('calling spot pages update with peer obj', peerObj);
			await this._spotpagesUpdated(peerObj);
		}

		window.peerListA = this._peerList;
	}

	async closePeer(id)
	{

		const index = this._peerList.findIndex((each) => each.id === id);

		if (index > -1)
		{
			this._peerList.splice(index, 1);
		}
	}

	async _spotpagesUpdated(peerObj)
	{
		// let spotlights;
		// let spotpaages = [];

		// spotpaages = this._peerList;

		// window.RPPeerTest = spotpaages;
		// alert(window.RPPeerTest)
		// const _totalScreens = this._roomClient.getPageLength();

		// const itemPerScreen = Math.ceil(spotpaages.length / _totalScreens);

		// const peersForThispage = spotpaages.slice((this._pageNumber - 1)
		// 						* itemPerScreen, this._pageNumber * itemPerScreen);

		// this._selectedSpotpages = peersForThispage;

		// alert(this._selectedSpotpages.length)

		// eslint-disable-next-line no-console
		// console.log('peersForThispagepeersForThispage', peersForThispage);

		// console.log('called spot pages update with peer obj', peerObj);

		// let leastLength = store.getState().room.tpScreenPagePeers.length > 0 ?
		// 	store.getState().room.tpScreenPagePeers[0].peers.length : 0;

		// for (const eachScreen of store.getState().room.tpScreenPagePeers)
		// {
		// 	if (eachScreen.peers.length < leastLength)
		// 	{
		// 		leastLength = eachScreen.peers.length;
		// 	}
		// }

		// console.log('least length:::', leastLength);

		const peersForThispage = [];

		const tpScreenData = store.getState().room.tpScreenPagePeers;

		for (const eachScreen of tpScreenData)
		{
			// console.log('inside of for loop:::', eachScreen);

			if (
				peerObj.id !== undefined && peerObj.displayName !== undefined &&
					eachScreen.peers.length < eachScreen.screenSeatLimit)
			{

				this._pageNumber = eachScreen.screenNumber;
				this._seatLimit = eachScreen.screenSeatLimit;

				peersForThispage.push(...eachScreen.peers, peerObj);
				break;
			}
			// else if (eachScreen.peers.length === eachScreen.screenSeatLimit)
			// {
			// 	this._pageNumber = eachScreen.screenNumber;
			// 	this._seatLimit = eachScreen.screenSeatLimit;

			// 	peersForThispage.push(...eachScreen.peers);
			// 	break;
			// }
		}

		if (peersForThispage.length > 0)
		{
			if (this._pageNumber === this.thisScreen)
			{
				const spotLightPeers = [];

				for (const peer of peersForThispage)
				{
					spotLightPeers.push(peer.id);
				}
				this._roomClient.updateSpotlights(spotLightPeers);
				// eslint-disable-next-line max-len
				await this._roomClient.setTPPeer(peersForThispage, this._pageNumber, this._seatLimit);

			}
		}

	}
}